import { useEffect, useState } from "react";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { CounterInputV2 } from "../../../FormControlsV2";

interface InfoInventoryProps {
    task: ITaskAnimalResolver | undefined;
}

export default function InfoInventory(task: InfoInventoryProps) {
    const [taskGrazingRoute, setTaskGrazingRoute] = useState<ITaskAnimalResolver>();

    useEffect(() => {
        setTaskGrazingRoute(task.task)
    }, []);

    return (
        <>
            <div >
                <span>Lote</span>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <AnimalsIcon width={30} className="iconInitialTaskInfo" />
                    <div className="labelInitialTaskInfo">
                        <span>{taskGrazingRoute?.batch_initials}</span>
                        <PointIcon width={15} />
                    </div>
                </div>
            </div>

            {taskGrazingRoute?.details.map((detail) => (
                detail.categories.map((category, index) => (
                    <div key={index} className="containerQuestion">
                        <CounterInputV2 name={`info-inventory-qty-${category.id}`} value={Number(category.quantity ?? 0)} disabled />
                        <MessageBalloon text={`${category.category_description.name} ${category.category_description.age_description}`} />
                    </div>
                ))
            ))}
        </>
    )
}